import {
    getUserGroup,

} from "@/service/account/manageUser";
import {
    listUserInCourseAll,
    removeUserInCourseAll,
    getUserBySearch,
    addUserInCourseBySearch,
    addStudentFromGroup,
    removeUserInCourseAllWithLimit,
} from '@/service/mylib/list';
export default {
    computed: {
        selectedGroups() {
            return this.$vuetify.lang.t(
                "$vuetify.learnerManagement.learnerList.selectedGroups"
            );
        },

        headers() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.learnerManagement.learnerList.photo'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.name"
                    ),
                    value: "fullName",
                    align: "start",
                    sortable: false,
                },
                // {
                //     text: this.$vuetify.lang.t(
                //         "$vuetify.learnerManagement.learnerList.username"
                //     ),
                //     value: "username",
                //     align: "start",
                //     sortable: false,
                // },
                // {
                //     text: this.$vuetify.lang.t(
                //         "$vuetify.learnerManagement.learnerList.email"
                //     ),
                //     value: "email",
                //     align: "start",
                //     sortable: false,
                // },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.group"
                    ),
                    value: "group",
                    align: 'center',
                    sortable: false,
                },
                // {
                //     text: this.$vuetify.lang.t(
                //         "$vuetify.learnerManagement.learnerList.username"
                //     ),
                //     value: "username",
                //     align: "start",
                //     sortable: false,
                // },

                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.status"
                    ),
                    value: "status",
                    align: "start",
                    sortable: false,
                },
            ];
        },
    },
    data: function () {
        return {
            params: {},
            arrayGroup: [],
            userGroupSearch: [],
            selectedGroupsForMove: [],
            users: [],
            loading: false,
            confirm_dialog: false,
            confirm_dialog_status: false,
            imageReady: false,
            dialogStatus: false,
            dialogStatusActive: false,
            dialogMoveGroup: false,
            dataStatus1: [],
            dataStatus2: [],
            loadingDelete: false,
            dialogMultiDeleteSuccess: false,
            dialogMultiDeleteFail: false,
            exp_date_dialog: false,

            page_student_delete: 1,
            pageCount_student_delete: 1,

            //date
            date: new Date().toISOString().substr(0, 10),
            nowdate: new Date().toISOString().substr(0, 10),
            menu1: false,
            date_type: 'type_life_time',
            data_type: '',
            actualTimeStamp: 0,
            actualTimeStampExp: 0,
        };
    },
    props: {
        isOpen: {
            type: Boolean,
        },
        isClose: {
            type: Function,
        },
        courseId: {
            type: String
        },
        sectionID: {
            type: String,
        },
    },
    watch: {
        isOpen: async function (newValue) {
            if (newValue) {
                this.userGroupSearch = [];
                this.users = [];
                this.params = {
                    search: null,
                    sort: "created_at",
                    sortby: -1,
                    usergroup: null,
                    page: 1,
                    limit: 1000,
                    active: "null",
                };
                this.paramsStudent = {
                    // search: null,
                    // sort: "created_at",
                    // sortby: -1,
                    usergroup: null,
                    page: 1,
                    limit: 10,
                    active: "null",
                    idcourse: this.courseId

                };
                console.log(newValue);
                this.getUserGroupList();
                // await getUserGroup()
            }
        },
    },

    methods: {
        closeDeleteDialog() {
            this.userGroupSearch = [];
            this.users = [];
            this.selectedGroupsForMove = [];
            this.closeDeleteUser();
        },
        async getUserGroupList() {
            let result = await getUserGroup(this.params);
            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            this.arrayGroup.push({
                title: 'ไม่มีกลุ่ม',
                _id: '',
            });
            await result.forEach(async (group) => {
                // let arrayGroup = []
                group.child_User_Group.length === 0
                    ? await this.arrayGroup.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.arrayGroup.push({
                            title: group.title + " -> " + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.arrayGroup.push({
                            title:
                                group.title + " -> " + child.title + " -> " + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
                // await userGroupAllAtIndex.push({arrayGroup})
            });
            console.log(this.arrayGroup);
            this.groupUsers = result;
            // this.filterGroupResult = result;
        },
        async applyFilter() {
            this.paramsStudent.usergroup = [];
            this.params.sort = null;
            this.params.sortby = null;
            if (this.status_toggle == 1) {
                this.params.active = true;
                this.params.page = this.page;
                this.paramsStudent.usergroup = await this.userGroupSearch;
                // console.log(this.paramsStudent.usergroup)
                if (this.userGroupSearch.length != 0) {
                    await this.getUserList();
                } else {
                    this.users = [];
                }
                console.log("if");
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.params.page = this.page;
                this.paramsStudent.usergroup = await this.userGroupSearch;

                if (this.userGroupSearch.length != 0) {
                    await this.getUserList();
                } else {
                    this.users = [];
                }
                console.log("else if");
            } else {
                this.params.active = "null";
                this.params.page = this.page;
                this.paramsStudent.usergroupOld = await this.userGroupSearch;

                if (this.userGroupSearch.length != 0) {
                    this.paramsStudent.usergroupNewArray = []
                    for (let index = 0; index < this.paramsStudent.usergroupOld.length; index++) {

                        this.paramsStudent.usergroup.push(
                            this.paramsStudent.usergroupOld[index]._id
                        )
                    }
                    await this.getUserList();
                } else {
                    this.users = [];
                }

                console.log("else");
            }
        },
        async getUserList() {
            this.loading = true;
            this.dataStatus1 = [];
            this.dataStatus2 = [];
            this.paramsStudent.usergroup = [];
            this.paramsStudent.groupnull = false;
            // localStorage.removeItem("editCourseID");
            // console.log(this.params);
            this.userGroupSearch.forEach(group => {
                if (group._id != "") {
                    this.paramsStudent.usergroup.push(group._id);
                } else {
                    this.paramsStudent.groupnull = true;
                }
            });
            let result = await getUserBySearch({
                usergroup: this.paramsStudent.usergroup,
                page: this.paramsStudent.page,
                limit: 10,
                groupnull : this.paramsStudent.groupnull
            });
            // let result = await listUserInCourseAll(this.paramsStudent);
            // console.log("getUserList -> result", result)
            this.users = [];
            this.pageCount_student_delete = Math.ceil(result.data.length / this.limit);
            this.pageCount_student_delete = result.maxPage;
            //   this.imageReady = false;
            await result.data.forEach(async (user) => {
                this.users.push({

                    id: user._id,
                    image: user.image,
                    fullName: user.firstName + " " + user.lastName,
                    email: user.email,
                    username: user.username,
                    status: await this.checkStatus(
                        user.myCourses,
                        user.myCoursesRequest
                    ),
                    user_groups: user.user_groups,
                    group: await this.showGroupList(user.user_groups),
                });
                if (user.active == false) {
                    this.dataStatus1.push({
                        id: user._id,
                    });
                } else {
                    this.dataStatus2.push({
                        id: user._id,
                    });
                }
            });
            //   this.imageReady = true;
            this.loading = false;
        },
        checkStatus(myCourses, myCoursesRequest) {
            let course = [];
            if (myCourses.length > 0) {
                for (let i = 0; i < myCourses.length; i++) {
                    if (myCourses[i]._id == this.courseId) {
                        course.push(myCourses[i]);
                    }
                }
            }
            if (myCoursesRequest.length > 0) {
                for (let i = 0; i < myCoursesRequest.length; i++) {
                    if (myCoursesRequest[i] == this.courseId) {
                        course.push(myCoursesRequest[i]);
                    }
                }
            }
            return course;
        },
        async showGroupList(userGroup) {
            let userGroupOutput = [];
            await userGroup.forEach(
                async (grouplist) =>
                    await this.arrayGroup.forEach(async (group) =>
                        group._id == grouplist._id
                            ? await userGroupOutput.push(group)
                            : null
                    )
            );
            return userGroupOutput;
        },

        openExpDateDialog(type, item) {
            this.data_type = type;
            if (this.data_type == 'search') {
                this.item_search = item;
            }
            this.exp_date_dialog = true;
        },

        async addUserByUser() {
            if (this.data_type == 'search' || this.data_type == 'clone') {

                this.addUserbySearch();
                this.closeDialogDateExp();
            }
        },

        async addUserbySearch() {
            this.loading = true;
            if (this.data_type == 'search') {
                let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
                var startTime = dt_start.setTime(
                    dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
                );
                this.actualTimeStamp = startTime;
                let expDate = new Date().toISOString().substr(0, 10);
                if (expDate == this.date) {
                    var actualDate = new Date();
                    var endOfDayDate = new Date(
                        actualDate.getFullYear(),
                        actualDate.getMonth(),
                        actualDate.getDate(),
                        23,
                        59,
                        59
                    );
                    var setTimeSatmpEnOfDay = endOfDayDate.setTime(
                        endOfDayDate.getTime()
                    );
                    this.actualTimeStamp = setTimeSatmpEnOfDay;
                }

                let data = {
                    idcourse: this.courseId,
                    idroom: this.sectionID,
                    exp: this.date_type == 'type_spectify_exp' ? this.actualTimeStamp : 0,
                    pricing: 0,
                    usergroup: this.paramsStudent.usergroup

                    // idprice:
                    //   this.detail.prices && this.detail.prices.length !== 0
                    //     ? this.detail.prices[0]._id
                    //     : ""
                };
                let result = await addStudentFromGroup(data);
                if (result.acceptMylib == true) {

                    this.getUserList();
                    this.closeDialogDateExp();
                    this.closeDialog();

                    this.loading = false;
                } else {

                    this.getUserList();
                    this.closeDialogDateExp();
                    this.closeDialog();

                    this.loading = false;
                }
            }
        },

        closeDialogDateExp() {
            this.exp_date_dialog = false;

            this.date = new Date().toISOString().substr(0, 10);
            this.nowdate = new Date().toISOString().substr(0, 10);
            this.menu1 = false;
            this.date_type = 'type_life_time';
        },

        closeDialog() {
            this.isClose();
            this.userGroupSearch = [];
            this.users = [];

        },

        async changePageStudent(page) {
            this.paramsStudent.page = page;
            this.users = [];
            await this.getUserList()
        },
    },
}
